import * as yup from "yup";
import { LEAVE_ICON_NAMES } from "./constants/iconsList";
import { APPROVAL_FLOW_KEYS } from "./constants/approvalFlow";

const baseSchema = yup.object({
  // Step 1
  isJustified: yup.boolean().required("Este campo es obligatorio"),
  code: yup.string().required("Este campo es obligatorio"),
  name: yup.string().required("Este campo es obligatorio"),
  incidenceTypeId: yup.string().required("Este campo es obligatorio"),
  icon: yup.string().when("isJustified", ([isJustified], schema) => {
    if (isJustified) return schema.strip();
    return schema
      .oneOf(LEAVE_ICON_NAMES, "El ícono seleccionado no es válido")
      .required("Este campo es obligatorio");
  }),

  // Step 2
  approvalFlow: yup.string().when("isJustified", ([isJustified], schema) => {
    if (isJustified) return schema.strip();
    return schema
      .oneOf(Object.values(APPROVAL_FLOW_KEYS))
      .required("Este campo es obligatorio");
  }),
  hasBalanceControl: yup
    .string()
    .when("isJustified", ([isJustified], schema) => {
      if (isJustified) return schema.strip();
      return schema.oneOf(["yes", "no"]).required("Este campo es obligatorio");
    }),
  
annualDays: yup
  .number()
  .transform((value, originalValue) =>
    originalValue === "" ? null : value
  )
  .when(
    ["isJustified", "hasBalanceControl"],
    ([isJustified, hasBalance], schema) => {
      if (isJustified) return schema.strip();

      if (hasBalance !== "yes") {
        return schema.nullable().notRequired();
      }

      return schema
        .typeError("El campo debe ser numérico")
        .integer("Debe ser un número entero")
        .required("Este campo es obligatorio")
        .min(1, "El mínimo es 1 día")
        .max(365, "El máximo es 365 días")
        .test(
          "annual-days-greater-than-max-per-request",
          "Los días anuales deben ser mayores o iguales a los días máximos por solicitud",
          function (value) {
            const { maxDaysPerRequest } = this.parent;

            if (value == null || maxDaysPerRequest == null) {
              return true;
            }

            return value >= maxDaysPerRequest;
          }
        );
    }
  ),
  maxDaysPerRequest: yup
    .number()
    .when(
      ["isJustified", "hasBalanceControl"],
      ([isJustified, hasBalance], schema) => {
        if (isJustified) return schema.strip();
        return schema
          .typeError("El campo debe ser numérico")
          .integer("Debe ser un número entero")
          .required("Este campo es obligatorio")
          .min(1, "El mínimo es 1 día")
          .max(365, "El máximo es 365 días")
      },
    ),
  resetMonth: yup
    .number()
    .when(
      ["isJustified", "hasBalanceControl"],
      ([isJustified, hasBalance], schema) => {
        if (isJustified) return schema.strip();
        if (hasBalance !== "yes") return schema.nullable().notRequired();
        return schema.required("Este campo es obligatorio").min(1).max(12);
      },
    ),
  requiresAttachment: yup
    .string()
    .when("isJustified", ([isJustified], schema) => {
      if (isJustified) return schema.strip();
      return schema.oneOf(["yes", "no"]).required("Este campo es obligatorio");
    }),
  advanceNoticeRequirement: yup
    .string()
    .when("isJustified", ([isJustified], schema) => {
      if (isJustified) return schema.strip();
      return schema
        .oneOf(["none", "required"])
        .required("Este campo es obligatorio");
    }),
  minAdvanceNoticeDays: yup
    .number()
    .when(
      ["isJustified", "advanceNoticeRequirement"],
      ([isJustified, advanceNotice], schema) => {
        if (isJustified) return schema.strip();
        if (advanceNotice !== "required")
          return schema.nullable().notRequired();
        return schema
          .typeError("El campo debe ser numérico")
          .integer("Debe ser un número entero")
          .required("Este campo es obligatorio")
          .min(1, "El rango válido es de 1 a 15 días")
          .max(15, "El rango válido es de 1 a 15 días");
      },
    ),
  allowBackdateDays: yup
    .string()
    .when("isJustified", ([isJustified], schema) => {
      if (isJustified) return schema.strip();
      return schema.oneOf(["yes", "no"]).required("Este campo es obligatorio");
    }),
  maxBackdateDays: yup
    .number()
    .when(
      ["isJustified", "allowBackdateDays"],
      ([isJustified, allowBackdate], schema) => {
        if (isJustified) return schema.strip();
        if (allowBackdate !== "yes") return schema.nullable().notRequired();
        return schema
          .typeError("El campo debe ser numérico")
          .integer("Debe ser un número entero")
          .required("Este campo es obligatorio")
          .min(1, "El rango válido es de 1 a 15 días")
          .max(15, "El rango válido es de 1 a 15 días");
      },
    ),
});

export const validationSchema = baseSchema.transform((value) => {
  const result = { ...value };

  if (value.hasBalanceControl !== "yes") {
    result.annualDays = null;
    result.resetMonth = null;
  }

  return result;
});
